export default {
  namespaced: true,
  commands: {
    title: "Custom command",
    title_main: "Custom command",
    action_add: 'Create custom command',
    action_update: 'Update custom command',
    base_commands: 'Base commands',
    custom_commands: 'Custom commands',
    fields: {
      name: {
        label: 'Command name',
        placeholder: 'Command name'
      },
      description: {
        label: 'Command description',
        placeholder: 'Command description'
      },
      alarm_compatible: {
        label: "Is it compatible with alarms?"
      },
      requirements: {
        label: 'Requirements (optional)'
      }
    },
    messages: {
      success_created: 'Custom command successfully created',
      success_updated: 'Custom command successfully updated',
      layout_empty: 'Cannot save an empty command',
      connections_empty: 'Connectionless nodes are not allowed',
      connections_qty_exceeded: 'Nodes with multiple connections are not allowed',
      incomplete_node_config: 'Incomplete configuration on the following nodes',
      alarm_category_requires_alarm_compatibility: 'This command is only compatible with alarms. Enable “Is it compatible with alarms?” to use it.',
    },
    btns: {
      delete_image: 'Delete image',
      create: 'Save',
      update: 'Save',
      custom: 'Custom',
      base: 'Base',
    },
    requirements: {
      cols: {
        col1: 'Type',
        col2: 'Config.',
        col3: 'Multiple selec.'
      }
    },
    list: {
      enable_unit_cameras_do: {
        name: "Activate cameras digital output",
        desc: "Activate digital output of the unit cameras",
      },
      enable_speaker: {
        name: "Activate DO1 of the router",
        desc: "Turn on the router digital output"
      },
      show_user_view: {
        name: "Show view/tab",
        desc: "Show a view/tab on SBO"
      },
      delay: {
        name: "Delay",
        desc: "",
        hint: "Amount of time in seconds:"
      },
      active_digital_output_camera: {
        name: "Activate digital output of the cameras",
        desc: "Activate digital output of the cameras",
        hint: "",
      },
      activate_digital_output_camera: {
        name: "Activate digital output of the cameras",
        desc: "Activate digital output of the cameras",
        hint: "",
      },
      deactivate_digital_output_camera: {
        name: "Deactivate digital output of the cameras",
        desc: "Deactivate digital output of the cameras",
        hint: "",
      },
      deactive_sound_router: {
        name: "Deactivate DO1 of the router",
        desc: "Turn off the router digital output",
        hint: "",
      },
      interphone_call: {
        name: "Interphone call",
        desc: "Make a interphone call"
      },
      active_digital_output_rtu_router: {
        name: "Activate digital output RTU router",
        desc: "Activate digital output of specific digital output from router",
        hint: "",
      },
      density_shoot: {
        name: "Perform real shoot of fog",
        desc: "Perform a real shoot of fog from the specified device",
      },
      density_test_shoot: {
        name: "Perform test shoot of fog",
        desc: "Perform a test shoot of fog from the specified device",
      },
      notification_command: {
        name: "Send notification",
        desc: "Send notification from diferent ways like SMS, Email, Webhook, Whatsapps ...",
      },
      show_action_plan: {
        name: "Show an action plan",
        desc: "Shows the specified action plan",
      },
      send_c5_edomex: {
        name: "Send alarm to C5 EDOMEX",
        desc: "Send information about an alarm to C5 EDOMEX",
      },
      camera_round: {
        name: "Round of cameras",
        desc: "Command to start a round of cameras",
      },
      assignment_cameras: {
        name: "Camera assignment",
        desc: "Camera assignment",
      },
      alarm_panel_activate_output: {
        name: "Alarm panel - Activate output",
        desc: "Alarm panel - Activate output",
      },
      alarm_panel_deactivate_output: {
        name: "Alarm panel - Deactivate output",
        desc: "Alarm panel - Deactivate output",
      },
      activate_device_output: {
        name: "Activate device output",
        desc: "Activate device output",
      },
      deactivate_device_output: {
        name: "Deactivate device output",
        desc: "Deactivate device output",
      },
      activate_camera_ptz_preset: {
        name: "Activate camera PTZ preset",
        desc: "Activate camera PTZ preset",
      },
      activate_generic_device_digital_output: {
        name: "Activate generic device digital output",
        desc: "Activate generic device digital output",
      },
      deactivate_generic_device_digital_output: {
        name: "Deactivate generic device digital output",
        desc: "Deactivate generic device digital output",
      },
      assign_action_plan: {
        name: "Assign task to users",
        desc: "Assign task to users",
      },
      assign_operational_form_task: {
        name: "Assign operational form task",
        desc: "Assigns a user a task to complete an operational security form",
      },
      notify_panel_failure: {
        name: "Panel failure",
        desc: "Notifies the device failure to the users with the alarm failure notification permission",
      },
      response_operational_form: {
        name: "Create operational form response",
        desc: "Creates an operational security form answer from a template",
      },
      "response-operational-form": {
        name: "Create operational form response",
        desc: "Creates an operational security form answer from a template",
      },
      dispatch_alarm: {
        name: "Dispatch alarm",
        desc: "Dispatch alarm",
      },
      create_helpdesk_ticket: {
        name: "Create helpdesk ticket",
        desc: "Create helpdesk ticket",
      },
      alarm_image_inference: {
        name: "Infer context from an image",
        desc: "Infer context from an image",
      },
      update_alarm_level_command: {
        name: "Update alarm level",
        desc: "Updates the level of an alarm",
      },
      update_alarm_status_command: {
        name: "Update the status of an alarm",
        desc: "Update the status of an alarm",
      },
      update_alarm_type_command: {
        name: "Update the type of an alarm",
        desc: "Update the type of an alarm",
      },
      update_alarm_category_command: {
        name: "Alarm category",
        desc: "Updates an alarm protocol with a catalog message",
      },
      ai_decision: {
        name: "AI Decision",
        desc: "AI Decision",
        decision: "Answer",
      },
      deactive_digital_output_rtu_router: {
        name: "Deactivate digital output RTU router",
        desc: "Deactivate digital output of specific digital output from router",
        hint: "",
      },
      action_execute_dmp_panel: {
        name: "Execute action in DMP panel",
        desc: "Execute action in DMP panel",
      },
      action_execute_intelbras_panel: {
        name: "Execute action in INTELBRAS panel",
        desc: "Execute action in INTELBRAS panel",
      },
      action_execute_pacom_panel: {
        name: "Execute action in PACOM panel",
        desc: "Execute action in PACOM panel",
      },
      assign_alarm_user: {
        name: "Assign alarm to user",
        desc: "Assign alarm to user",
      },
      activate_digital_output_hikvision_camera: {
        name: "Activate digital output of a Hikvision camera",
        desc: "Activate digital output of a Hikvision camera",
      },
      action_execute_panel_from_alarm: {
        name: "Execute action in panel from alarm",
        desc: "Execute action in panel from alarm",
      },
      send_external_cad_emergency_test: {
        name: 'Send external cad emergency test'
      },
      batch_alarm_attention: {
        name: 'Batch alarm attention',
        desc: 'Batch alarm attention'
      },
    },
    form: {
      units_select: {
        label: 'Select units for this node:'
      },
      cameras_select: {
        label: 'Select cameras for this node:'
      },
      user_views_select: {
        label: 'Select views/tabs for this node:'
      },
      users_select: {
        label: 'Select the users for this node:'
      },
      profiles_select: {
        label: 'Select destination profiles:',
        hint: 'Destination profiles must have the "Receive notifications from the Notification command" permission.',
      },
      interphone_from: {
        label: 'Select the source phone:'
      },
      interphone_to: {
        label: 'Select the destination phone:'
      },
      density_device: {
        label: 'Select device Density:'
      },
      type_notificaction: {
        label: 'Type notification:'
      },
      type_verb_webhook: {
        label: 'RESTful verb:'
      },
      url1: {
        label: 'Enter the URL of alarm',
      },
      url2: {
        label: 'Enter the URL of feedbacks of alarm',
      },
      action_plan: {
        label: 'Select an action plan:'
      },
      operational_form_template_select: {
        label: 'Select the operational form template:'
      },
      alarm_select: {
        label: 'Link an alarm (optional):'
      },
      comment: {
        label: 'Comment (optional)'
      },
      comment_field: {
        label: 'Comment (optional)'
      },
      layouts: {
        label: 'Select a layout:'
      },
      location: {
        label: 'Enter the location:',
        fields: {
          lat: 'Latitude',
          lng: 'Longitude',
          from_alarm: 'Take value from alarm'
        }
      },
      radius: {
        label: 'Enter the radius:'
      },
      delay: {
        label: 'Enter the delay:'
      },
      loop: {
        label: 'Loop:'
      },
      message_template: {
        label: 'Message template',
        characters_remaining: 'Characters remaining',
        available_placeholders: 'Available placeholders',
        insert_placeholder: 'Insert placeholder',
        placeholder_hint: 'Type @ to search and insert a placeholder.',
        search_placeholder: 'Search placeholder…',
        no_placeholders_found: 'No placeholders found.',
        categories: {
          alarm: 'Alarms',
          location: 'Location',
          camera: 'Camera',
          media: 'Media',
          other: 'Other',
        },
        placeholders: {
          alarm_image: 'Image URL when the alarm comes from a video analytics event',
          alarm_image_url: 'Image URL when the alarm comes from a video analytics event',
          municipality: 'Facility municipality',
          region: 'Facility region',
          facility_format: 'Text before the first "_" in the facility description (MBA in MBA_3030)',
          facility_determinant: 'Text after the first "_" in the facility description (3030 in MBA_3030)',
          camera_name: 'Name of the camera associated with the alarm',
          facility_comment: 'Facility comments',
        },
        help: {
          header: 'Write the text that will be sent by WhatsApp. You can use the following placeholders that will later be replaced with the alarm information:',
          footer: {
            title: 'Example',
            body: 'Command executed from facility @facility_name, alarm id #@id_alarm of type @alarm_type'
          }
        }
      },
      subject: {
        label: 'Subject',
      },
      groups_select: {
        label: 'Select the groups for this node:'
      },
      tenants_select: {
        label: 'Select the tenants for this node:'
      },
      centers_select: {
        label: 'Select the centers for this node:'
      },
      sectors_select: {
        label: 'Select the sectors for this node:'
      },
      filter_field: {
        label: 'Add filter for this node:'
      },
      email: {
        label: 'Enter the emails',
      },
      phone: {
        label: 'Enter the phones',
      },
      receiver: {
        label: 'Enter the receiver',
      },
      authorization: {
        label: 'Enter your authorization key'
      },
      json_editor: {
        apply: 'Apply',
        cancel: 'Cancel',
        expand: 'Open JSON editor',
        format: 'Format JSON',
        invalid: 'Invalid JSON',
        title: 'JSON template editor',
        valid: 'Valid JSON',
      },
      alarm_panels: {
        label: 'Select an alarm panel:',
      },
      alarm_panel_devices: {
        label: 'Select the panel device:',
        hint: 'Note: When the value will be taken from an alarm, "Input" and "Zone" are the same.'
      },
      cmd_config: {
        label: 'Command configuration',
        hint: 'Select the command and then define its settings below.'
      },
      camera_ptz_presets: {
        label: 'PTZ camera presets',
        hint: 'Type or select a PTZ preset for the camera'
      },
      device_tags: {
        label: 'Device tags',
        hint: 'Type or select a device tag'
      },
      device_proxy_id: {
        label: 'Device',
        hint: 'Select a device'
      },
      alarm_types: {
        label: 'Select an alarm types',
        hint: 'Select an alarm types'
      },
      helpdesk_users_from: {
        label: 'Select a user',
        hint: 'Select the user who will create the ticket'
      },
      helpdesk_users_to: {
        'label': 'Select the users',
        'hint': 'Select the users who should receive a copy of the e-mail'
      },
      helpdesk_groups: {
        label: 'Groups',
        hint: 'Select the groups associated with the ticket'
      },
      prompt: {
        label: 'Enter a prompt',
      },
      alarm_levels: {
        label: 'Select an alarm level',
      },
      alarm_status: {
        label: 'Select an alarm status',
      },
      message: {
        label: 'Add a message',
      },
      group_name: {
        label: 'Group name',
        hint: 'Enter the name of the group.'
      },
      cat_base_url: {
        label: 'Url'
      },
      cat_user_id: {
        label: 'User Id'
      },
      cat_timeout: {
        label: 'Timeout'
      },
      sectors: {
        label: 'Select a sector',
        hint: 'Select a sector.'
      },
    },
    data_types: {
      users: 'Users',
      profiles: 'Profiles',
      user_views: 'User views',
      units: 'Facilities',
      cameras: 'Cameras',
      phone: 'Phones',
      email: ' E-mails',
      log_id: 'Logs',
      do: 'Digital Output',
      interphone_from: 'Interphone call (from)',
      interphone_to: 'Interphone call (to)',
      message_template: 'Message',
      subject: 'Subject',
      type: 'Type of notification',
      receiver: 'Receiver',
      verb: 'RESTful verb',
      authorization: 'Authorization',
      url1: 'URL alarm',
      url2: 'URL comments alarm',
      webhook: 'URL Webhook',
      action_plan: 'Action plan',
      operational_form_template: 'Operational form template',
      alarm: 'Alarm',
      alarm_category_message: 'Alarm category message',
      comment: 'Comment',
      delay: 'Delay',
      layout: 'Layouts',
      location: 'Location',
      radius: 'Radius',
      loop: 'Loop',
      density_device: 'Density device',
      groups: 'Groups',
      tenants: 'Tenants',
      centers: 'Centers',
      sectors: 'Sectors',
      filter: 'Filters',
      alarm_panels: 'Alarm panels',
      alarm_panel_devices: 'Alarm panel devices',
      cmd_config: 'Command configuration',
      camera_ptz_presets: 'PTZ camera presets',
      device_tags: 'Device tags',
      device_proxy_id: 'Device',
      alarm_types: 'Alarm types',
      helpdesk_groups: 'Helpdesk groups',
      helpdesk_users_from: 'User',
      helpdesk_users_to: 'Users',
      commands:{
        form: {
          cameras_select: {
            label: 'Select cameras'
          }
        }
      }
    },
    flowchart: {
      show_hide_node_config: 'Show/hide command settings',
    },
    gridWidget: {
      title: 'Scripts',
      table: {
        no_data: "No data available",
        rows: {
          1: "Name",
          2: "Description",
        }
      }
    },
    cameras: {
      label: 'Cameras'
    },
    modal: {
      title: 'Script Execution',
      body: 'The following script will be executed',
      btns: {
        continue: 'Continue',
        cancel: 'Cancel'
      },
      messages: {
        success: 'Status: Command executed successfully',
        error: 'Status: An error occurred'
      }
    },
    config_modal: {
      title: 'Command configuration',
      messages: {
        invalid_form: 'Please correct the errors in the form',
      },
      chart: {
        label: 'Embedded chart',
        hint: 'Show a chart inside the node box (demo data).',
        types: {
          none: 'None',
          bar: 'Bar',
          line: 'Line',
          pie: 'Pie',
          graph: 'Graph (force)',
        }
      }
    },
    logs: {
      title: 'Command Logs',
      filters: {
        commands: 'Commands'
      },
      table: {
        id_operation: 'Operation ID',
        user: 'User',
        description: 'Description',
        command: 'Command',
        command_source: 'Related comando',
        level: 'Level',
        data: 'Info',
        date: 'Date'
      }
    },
    units: {
      seconds: 'second(s)',
      meters: 'meter(s)',
    },
    panels: {
      user_panel: 'Panel',
      device_panel: 'Device',
      action_panel: 'Action'
    },
    device_action_panel: {
      title: 'Device action',
      action: 'Action',
      actions: {
        RESTORE: 'Restore',
        RESET: 'Reset',
        BYPASS: 'Bypass',
        ARM: 'Arm',
        DISARM: 'Disarm',
      },
    }
  }
}
